import { BarChart } from "@mantine/charts";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import { Group, Paper, Text } from "@mantine/core";
import LoaderStats from "../../LoaderStats";
import { useMemo } from "react";
import { getChartColors } from "../../../../../functions/utilFunctions";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useLeadsStore } from "../../../../../stores/LeadsStore";

const LeadsSummaryMulti = () => {
  const lang = useLanguage((s) => s.language);
  const progStats = useReportingStore((s) => s.progStats);
  const systemStatus = useLeadsStore((s) => s.systemStatuses);
  const customStatus = useLeadsStore((s) => s.customStatuses);

  const series = useMemo(() => {
    let allStatus = [...systemStatus, ...customStatus].map((item, index) => ({
      name: item.name,
      color: item.color ? `#${item.color}` : `${getChartColors()[index]}.5`,
    }));
    return allStatus;
  }, [customStatus, systemStatus]);

  const data = useMemo(() => {
    let customData = [];

    progStats.forEach((item) => {
      const mergedStats = item.stats.reduce(
        (acc, obj) => {
          for (const key in obj) {
            if (key === "prm_contacts_status") {
              // Merge and sum objects by custom_status_id
              obj[key].forEach((status) => {
                const existingStatus = acc.prm_contacts_status.find(
                  (s) => s.custom_status_id === status.custom_status_id
                );
                if (existingStatus) {
                  existingStatus.contacts_total += status.contacts_total;
                } else {
                  acc.prm_contacts_status.push({ ...status });
                }
              });
            } else if (typeof obj[key] === "number") {
              // Sum numerical values
              acc[key] = (acc[key] || 0) + obj[key];
            } else {
              // Keep last encountered value for non-numeric types
              acc[key] = obj[key];
            }
          }
          return acc;
        },
        { prm_contacts_status: [] }
      );

      let customStatusData = {};
      mergedStats.prm_contacts_status.forEach((x) => {
        let status = customStatus.find((y) => y.id === x.custom_status_id);

        customStatusData[status.name] = x.contacts_total;
      });
      customData.push({
        prog: item.prog.workflow_name,
        [lang.components.status_selector.statuses.opener]:
          mergedStats.opener_total,
        [lang.components.status_selector.statuses.clicker]:
          mergedStats.clicker_total,
        [lang.components.status_selector.statuses.answerer]:
          mergedStats.answerer_total,
        ...customStatusData,
      });
    });

    return customData;
  }, [
    customStatus,
    lang.components.status_selector.statuses.answerer,
    lang.components.status_selector.statuses.clicker,
    lang.components.status_selector.statuses.opener,
    progStats,
  ]);

  return (
    <Paper pos={"relative"} w={"100%"} p={"xl"} pt={"md"}>
      <LoaderStats isDate />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.volume_per_campaigns}
        </Text>
      </Group>

      <BarChart
        h={300}
        w={"100%"}
        data={data}
        dataKey="prog"
        type="stacked"
        series={series}
        tickLine="y"
        yAxisLabel="Contacts"
        xAxisLabel="Status"
      />
    </Paper>
  );
};

export default LeadsSummaryMulti;
